import * as React from 'react';
import * as classes from './vendor-info.scss';
import { OptionsViewModel, AddressViewModel } from '@models/common.models';
import { dateParser } from '@common/dateParser';
import { EditLink } from '@common/components/wizard/_components/wizard-edit-link.component';
import { DynamicSelectLookup } from '@common/components/dynamic-select-lookup/dynamic-select-lookup.component';
import { getRoute, RouteDefinitions } from '@common/route-definitions';
import { Link } from 'react-router-dom';

export interface VendorInfoAddressNFinancesProperties {
  readonly jump?: (step: number) => void | undefined;
  readonly id: number;
  readonly address: AddressViewModel;
  readonly apName: string;

  readonly parentId: number;
  readonly vendorType: OptionsViewModel;
  readonly vendorTypeOptions?: OptionsViewModel[];
  readonly vendorStatus: OptionsViewModel;
  readonly vendorStatusOptions?: OptionsViewModel[];
  readonly licenseNumber: string;
  readonly licenseExpiration?: Date;

  readonly taxId: string;
  readonly has1099?: boolean;
  readonly w9Status: OptionsViewModel;
  readonly w9StatusOptions?: OptionsViewModel[];
  readonly w9TaxYear: string;
  readonly w9SignedDate: Date;

  readonly isTab?: boolean;
}

export class VendorInfoAddressNFinancesComponent extends React.Component<VendorInfoAddressNFinancesProperties> {
  render() {
    return (
      <section className={!this.props.isTab ? [classes.summary, 'row col-md-12'].join(' ') : classes.summary}>
        <div
          className={
            !this.props.isTab ? [classes.summaryCardRight, 'col-md-12 light-gray-bc'].join(' ') : classes.summary
          }
        >
          <div className="col-xs-12">
            <div className="row">
              <div className="col-xs-9">
                <h4>
                  {'Address & Finances'}{' '}
                  {this.props.isTab && (
                    <Link to={getRoute(RouteDefinitions.vendor.Edit, { id: +this.props.id })}>Edit</Link>
                  )}
                </h4>
              </div>
              <div className="col-xs-3 text-right">
                <h4>{!this.props.id ? <EditLink step={1} jump={this.props.jump} /> : ''}</h4>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label>Office Address</label>
                <h5>
                  {this.props.address && this.props.address.line1 && this.props.address.line1.length > 0
                    ? this.props.address.line1
                    : '--'}
                </h5>
              </div>
              <div className="col-md-6">
                <label>Address 2</label>
                <h5>
                  {this.props.address && this.props.address.line2 && this.props.address.line2.length > 0
                    ? this.props.address.line2
                    : '--'}
                </h5>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <label>City</label>
                <h5>{this.props.address ? this.props.address.city : '--'}</h5>
              </div>
              <div className="col-md-2">
                <label>State</label>
                <h5>{this.props.address && this.props.address.state ? this.props.address.state.abbreviation : '--'}</h5>
              </div>
              <div className="col-md-2">
                <label>Zip</label>
                <h5>{this.props.address ? this.props.address.zip : '--'}</h5>
              </div>
              <div className="col-md-5">
                <label>A/P Name</label>
                <h5>{this.props.apName ? this.props.apName : '--'}</h5>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <label>Parent</label>
                <h5>{this.props.parentId || '--'}</h5>
              </div>
              <div className="col-md-2">
                <label>Vendor Type</label>
                <h5>
                  {this.props.vendorType ? (
                    <DynamicSelectLookup optVM={this.props.vendorType} opts={this.props.vendorTypeOptions} />
                  ) : (
                    '--'
                  )}
                </h5>
              </div>
              <div className="col-md-2">
                <label>Vendor Status</label>
                <h5>
                  {this.props.vendorStatus ? (
                    <DynamicSelectLookup optVM={this.props.vendorStatus} opts={this.props.vendorStatusOptions} />
                  ) : (
                    '--'
                  )}
                </h5>
              </div>
              <div className="col-md-3">
                <label>License Number</label>
                <h5>{this.props.licenseNumber || '--'}</h5>
              </div>
              <div className="col-md-2">
                <label>License Expires</label>
                <h5>
                  {this.props.licenseExpiration
                    ? dateParser.parse(this.props.licenseExpiration).format('MM/DD/YYYY') || '--'
                    : '--'}
                </h5>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <label>Federal Tax ID</label>
                <h5>{this.props.taxId || '--'}</h5>
              </div>
              <div className="col-md-2">
                <label>1099?</label>
                {/* <h5>{this.props.has1099 ? 'true' : 'false'}</h5> */}
                <h5>
                  <i className={this.props.has1099 ? 'fa fa-check' : 'fa fa-times'} />
                </h5>
              </div>
              <div className="col-md-2">
                <label>W9 Status</label>
                <h5>
                  {this.props.w9Status ? (
                    <DynamicSelectLookup optVM={this.props.w9Status} opts={this.props.w9StatusOptions} />
                  ) : (
                    '--'
                  )}
                </h5>
              </div>
              <div className="col-md-3">
                <label>W9 Signed Date</label>
                <h5>
                  {this.props.w9SignedDate ? dateParser.parse(this.props.w9SignedDate).format('MM/DD/YYYY') : '--'}
                </h5>
              </div>
              <div className="col-md-2">
                <label>W9 Tax Year</label>
                <h5>{this.props.w9TaxYear}</h5>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-info/vendor-info-address-n-finances.component.tsx